import { observer } from "mobx-react";
import PolicyStore from "../../../../../stores/policy-store";
import { IValidationGroup } from "../../../../../../../hooks/validation-group/validation-group-hook";
import { FormFieldLine } from "../../../../../../../components/form-field-line/form-field-line";
import { Toggle } from "../../../../../../../components/inputs/toggle/toggle";
import Hr from "../../../../../../../components/hr/hr";
import { SelectDropdown } from "../../../../../../../components/inputs/select-dropdown/select-dropdown";
import { AUTO_PROCESS_TRIGGER, AUTO_PROCESS_VALIDATED_QUALIFIER } from "../../../../../../../models/User";
import { autoProcessValidatedQualifierOptionsList } from "../../../../../constants";

interface IProps {
    policy: PolicyStore;
    validationGroup: IValidationGroup;
}

const OfferInsantExchange: React.FC<IProps> = observer(({ policy, validationGroup }) => {
    const selectedCapturePaymentTrigger = policy.instantRefundTriggerOptionsList.find(o => o.value === policy.capturePaymentTrigger);
    const selectedCapturePaymentQualifier = autoProcessValidatedQualifierOptionsList().find(o => o.value === policy.capturePaymentValidatedQualifier);

    return (
        <>
            <Hr/>
            <FormFieldLine
                label='Offer Instant Exchange'
                note='Enable to give the customer the option to choose instant exchange for this policy rule.'
            >
                <Toggle label='' checked={policy.instantExchangeEnabled} onChange={policy.setInstantExchangeEnabled} />
            </FormFieldLine>
            {policy.instantExchangeEnabled &&
                <>
                    <FormFieldLine
                        label='Capture balance payment trigger'
                        note='Choose the trigger when ReturnGO will automatically capture the exchange order balance (The amount the customer agreed to pay)'
                    >
                        <SelectDropdown
                            value={selectedCapturePaymentTrigger}
                            options={policy.instantRefundTriggerOptionsList}
                            onChange={(v) => policy.setCapturePaymentTrigger(v?.value as AUTO_PROCESS_TRIGGER)}
                            required
                            validationGroup={validationGroup}
                        />
                    </FormFieldLine>
                    {policy.capturePaymentTrigger === AUTO_PROCESS_TRIGGER.ITEMS_VALIDATED &&
                        <FormFieldLine label='Validated is'>
                            <SelectDropdown
                                value={selectedCapturePaymentQualifier}
                                options={autoProcessValidatedQualifierOptionsList()}
                                onChange={(v) => policy.setCapturePaymentValidatedQualifier(v?.value as AUTO_PROCESS_VALIDATED_QUALIFIER)}
                                required
                                validationGroup={validationGroup}
                            />
                        </FormFieldLine>
                    }
                </>
            }
        </>
    );
});

export default OfferInsantExchange;